import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Carousel from "react-bootstrap/Carousel";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import banner from "../assets/images/e.webp";

import Banner1 from "../assets/images/bet-frenzy/Banner_1_1_2.png";
import Banner2 from "../assets/images/bet-frenzy/Banner_2_1.png";
import Banner3 from "../assets/images/bet-frenzy/Banner_3.png";
import Banner4 from "../assets/images/bet-frenzy/Banner_4.png";
import { LoginModal, MFAModal, SignupModal, WalletModal } from "./model";

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  const [banners, setBanners] = useState([]);
  const [isSignupOpen, setSignupOpen] = useState(false);
  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [isMFAOpen, setIsMFAOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isForgotPINOpen, setForgotPINOpen] = useState(false);

  const { data: configData } = useSelector((state) => state.config);
  const { data: profileData } = useSelector((state) => state.getProfile);

  // Update banners from config or fallback
  useEffect(() => {
    setLoading(true);

    if (configData?.banners?.length > 0) {
      setBanners(configData.banners);
      setLoading(false);
    } else {
      setBanners(
        isDesktop
          ? [{ image: Banner1 }, { image: Banner2 }]
          : [{ image: Banner3 }, { image: Banner4 }]
      );
      setLoading(false);
    }
  }, [configData, isDesktop]);

  // Track screen resize
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSelect = (selectedIndex) => setIndex(selectedIndex);

  const switchToLogin = () => {
    setSignupOpen(false);
    setLoginOpen(true);
    // TODO: implement actual login modal if needed
  };

  const switchToSignup = () => {
    setLoginOpen(false);
    setSignupOpen(true);
  };

  const getBannerHeight = () => {
    if (window.innerWidth > 1500) return "300px";
    if (window.innerWidth > 1350) return "250px";
    return "250px";
  };
  return (
    <>
      {loading ? (
        <div className="d-flex flex-wrap justify-content-center">
          <SkeletonTheme baseColor="#2a2d3e" highlightColor="#3e4259">
            <Skeleton width={300} height={300} style={{ margin: "5px" }} />
          </SkeletonTheme>
        </div>
      ) : (
        <Carousel activeIndex={index} onSelect={handleSelect}>
          {banners.length &&
            banners.map((item, idx) => (
              <Carousel.Item key={idx} className="p-1">
                <div
                  className="position-relative hero-carosel-banner-img-container"
                  // style={{
                  //   marginTop: "1.875rem",
                  //   width: "100%",
                  //   height: "100%",
                  //   display: "flex",
                  //   justifyContent: "center",
                  //   alignItems: "center",
                  // }}
                >
                  {item?.image || item?.image_for_mobile ? (
                    <img
                      className="hero-carosel-banner-img"
                      draggable="false"
                      alt="carousel-banner"
                      src={
                        isDesktop
                          ? item?.image
                          : item?.image_for_mobile
                          ? item?.image_for_mobile
                          : banner
                      }
                      // style={{
                      //   objectFit: "cover",
                      //   width: "100%",
                      //   height: "100%",
                      // }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#eaeaea",
                      }}
                    />
                  )}

                  {!isDesktop && (
                    <span
                      className="position-absolute box-green text-white-btn px-5 fs-14 cursor-pointer hero-carousel-text-btn"
                      onClick={() =>
                        profileData
                          ? setIsWalletOpen(true)
                          : setSignupOpen(true)
                      }
                    >
                      {profileData ? "Deposit" : "Register"}
                    </span>
                  )}
                </div>
              </Carousel.Item>
            ))}
        </Carousel>
      )}

      {/* Modals */}
      <WalletModal
        open={isWalletOpen}
        setOpen={setIsWalletOpen}
        mfaOpen={isMFAOpen}
        setmfaOpen={setIsMFAOpen}
      />
      <MFAModal open={isMFAOpen} setOpen={setIsMFAOpen} fromDirect={false} />
      <SignupModal
        open={isSignupOpen}
        setOpen={setSignupOpen}
        switchToLogin={switchToLogin}
      />
      <LoginModal
        open={isLoginOpen}
        setOpen={setLoginOpen}
        switchToSignup={switchToSignup}
        openForgotPINModal={() => {
          setLoginOpen(false);
          setForgotPINOpen(true);
        }}
      />
    </>
  );
};

HeroCarousel.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
};

export default HeroCarousel;
